// extracted by mini-css-extract-plugin
export default {"filterContainer":"foods_filterContainer__4ltJ7","container":"foods_container__OtU7V","title":"foods_title__76MDC"};